import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectsDocumentType } from "../../../types/ScientificModule";

const initialState: ProjectsDocumentType = {
    id: "",
    docBase64: "",
    idProject: "",
    status: false,
};

const projectsDocumentsSlice = createSlice({
    name: "projectsDocuments",
    initialState,
    reducers: {
        setProjectsDocumentsData: (
            state,
            action: PayloadAction<ProjectsDocumentType>
        ) => ({ ...state, ...action.payload }),
        resetProjectsDocumentsData: () => ({ ...initialState }),
    },
});

export const { setProjectsDocumentsData, resetProjectsDocumentsData } =
    projectsDocumentsSlice.actions;

export default projectsDocumentsSlice.reducer;
